import { styled as u, Button as y } from "@mui/material";
import C from "./ApeironButtonDisableTip.js";
import { GASharedEventCategory as N } from "../../../constants/googleAnalytics.js";
import A from "../../../hooks/analytics/useGoogleTagManager.js";
import B from "next/link";
import * as e from "ramda";
import * as l from "ramda-adjunct";
import { useCallback as c } from "react";
import { jsx as d } from "react/jsx-runtime";
const D = u(y)`
  background-color: var(--background-color);
  border-radius: unset;
  color: white;
  font-size: 16px;
  font-weight: unset;
  height: unset;
  line-height: 1;
  min-height: unset;
  min-width: unset;
  padding: unset;
  text-decoration: var(--text-decoration);
  text-transform: unset;
  width: unset;

  :hover {
    background-color: var(--background-color);
    text-decoration: var(--text-decoration);
  }

  &.Mui-disabled {
    opacity: 0.5;
    pointer-events: all;
    :active {
      pointer-events: none;
    }
  }
`, E = u(B)`
  text-decoration: none;
  text-align: center;
`, T = (p) => {
  const {
    children: m,
    disabled: r,
    disableReason: f,
    enableLink: a = !0,
    id: t,
    target: g,
    url: n = "",
    onClick: i,
    ...h
  } = p, {
    gtmEmitEvent: s
  } = A(), k = c((o) => {
    if (o.stopPropagation(), e.isNil(i) || (a || o.preventDefault(), i(o)), !e.isNil(t) && e.includes("#", t)) {
      const [x, w] = e.split("#", t);
      s(N.Click, {
        label: x,
        value: w || ""
      });
    }
  }, [i, t, a, s]), b = c((o) => {
    o.stopPropagation();
  }, []), v = l.isNotNil(n) && l.isNotEmpty(n) ? {
    component: E,
    href: n,
    target: g
  } : {};
  return /* @__PURE__ */ d(C, {
    disabled: r,
    reason: f,
    children: /* @__PURE__ */ d(D, {
      ...h,
      ...v,
      disabled: r,
      id: t,
      onClick: k,
      onMouseDown: b,
      children: m
    })
  });
};
export {
  T as default
};
//# sourceMappingURL=ApeironLinkButton.js.map
